@for (item of functionalUnitList; track item.fUnit.functionalUnit) {
  <ng-container
    *ngTemplateOutlet="
      item.isInGrid ? fnUnitTemplate : noFnUnitTemplate;
      context: {
        $implicit: { item, klass: formatClassName(item.fUnit.functionalUnit) },
      }
    "
  ></ng-container>
}

<ng-template #fnUnitTemplate let-data>
  <app-cts-gantry-functional-unit-step-list
    id="{{ 'fn-step-list-' + data.klass }}"
    [class]="data.klass"
    [ctsGantryGridHighlight]="data.klass"
    [functionalUnit]="data.item.fUnit"
    [stepsDefinition]="stepsDefinition"
  ></app-cts-gantry-functional-unit-step-list>
</ng-template>

<ng-template #noFnUnitTemplate let-data>
  <div [class]="data.klass" [ctsGantryGridHighlight]="data.klass">
    <div class="no-fn-unit">
      <sh-text color="secondary">
        {{ 'cts.gantry.na' | translate }}
      </sh-text>
    </div>
  </div>
</ng-template>
